import { useEffect, useState } from "react"
import { useGetHepQuery } from "./hepApiSlice"
import { useGetUsersQuery } from '../users/usersApiSlice'
import Hep from "./Hep"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePen } from '@fortawesome/free-solid-svg-icons'
import { pageSizes }  from "../../config/pages"
import {isMobileDevice} from "../../config/functions"


const HepList = () => {
    useTitle('DPE: HEP List')

    const { userId, username, isManager, isAdmin, token } = useAuth()
    const isMobile=isMobileDevice()


    // get user data for manager: start
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })
    let staffMembers=null
    if (isManager) {
        // get staff members, used for managers only
        staffMembers=user.staff

        // add manager id for current users
        staffMembers= [...staffMembers, userId]
    }
    // get user data for manager: end


    // Admin functions
    async function onHepClicked()  {
        // delete uploaded HEP's

        let server_url='';
        if (process.env.NODE_ENV === 'production') {
            server_url='https://dpe-mern-server.onrender.com/files/remove'
        } else {
            server_url='http://localhost:3500/files/remove'
        }
    
        try {
            const response = await fetch(server_url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                  },
            });
            const data = await response.json();

            if (response.status===200) {
                toast.success('Files were Removed');
            } else {
                toast.error(<>Files were NOT Deleted:<br/>{data.message}</>);
            }

        } catch (error) {
            toast.error('Error removing files:' + error);
        }
    }

    // filter HEP for Admin
    const [filterAdmin, setFilterAdmin] = useState(true)
    const onAdminChanged = () => {
        setFilterAdmin(prev => !prev)
    }



    // get hep list
    const {
        data: hep,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetHepQuery('hepList')


    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }

    }, [isError, error])

    let content
    if (isLoading) content = <PulseLoader color={"#5f788a"} />


    // pagination: 1
    const [currentPage, setcurrentPage]= useState(1)
    const [itemsPerPage, setitemsPerPage]= useState(6)
    const updateitemsPerPage = (e) => {
        setitemsPerPage(e.target.value)
        setcurrentPage(1)
    }




    if (isSuccess) {
        const { ids, entities } = hep

        let filteredIds=null
        if (isAdmin) {
            if (filterAdmin) {
                filteredIds = ids.filter(hepId => entities[hepId].username === username)
            } else {
                filteredIds = [...ids]
            }
        } else if (isManager){
            //only show HEP for staff members
            filteredIds = ids.filter(hepId => staffMembers.includes(entities[hepId].user))
        } else {
            // only show HEPs for current users or for themselves
            filteredIds = ids.filter(hepId => entities[hepId].username === username)
        }


        // pagination: 2
        const totalItems= filteredIds.length
        const lastIndex= currentPage * itemsPerPage
        const firstIndex= lastIndex- itemsPerPage
        const currentPageItems = filteredIds.slice(firstIndex, lastIndex)
        let lastPage =  Math.ceil(totalItems / itemsPerPage)
        const pages = []
        if (totalItems <= itemsPerPage) {
            let i=1
            pages.push(i)
            lastPage=1
        } else {
            for (let i=1 ; i < lastPage+1 ; i++){                
                pages.push(i)
            }
        }
        
        let prevActive= currentPage===1 ? 'page-item disabled' : 'page-item'
        let nextActive= currentPage===lastPage ? 'page-item disabled' : 'page-item'


        let tableHeaders
        if (isMobile) {
            tableHeaders=(
                <tr>
                    <th>Title</th>
                    <th>Therapist</th>
                    <th>Edit</th>
                </tr>
            )
        } else {
            tableHeaders=(
                <tr>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Title</th>
                    <th>Therapist</th>
                    <th>Edit</th>
                </tr>
            )
        }

        // create rows for the table
        const tableContent = currentPageItems.map(hepId => <Hep key={hepId} hepId={hepId} isMobile={isMobile} />)


        content = (
            <section id="main_content">
                <header>
                    <div className="row">
                        <div className="col-md-8">
                            <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faFilePen} style={{fontSize:"30px", marginRight:"5px"}}/>Home Programs</h1>
                        </div>
                        <div className="col-md-4 text-end mt-3">
                            {totalItems} Programs
                        </div>
                    </div>
                </header>
                <main>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                {tableHeaders}
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>
                    </div>

                    <div className="row g-0 mt-3">
                        <div className="col-md-10 col-xs-7">
                            <ul className="pagination">
                                <li className={prevActive}>
                                    <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage-1)}>Previous</span>
                                </li>
                                {
                                    // Show max of 8 pages
                                    pages.length < 9 &&
                                    pages.map((page, index) =>{
                                        let clsName = currentPage-1===index ? 'page-item active' : "page-item"
                                        return(
                                            <li key={index} className = {clsName}>
                                                <span className="page-link" role="button" onClick={() => setcurrentPage(page)}>{page}</span>
                                            </li>
                                        )
                                    })
                                }
                                <li className={nextActive}>
                                    <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage+1)}>Next</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2 col-xs-5 text-end mt-2">
                            <select name="itemsPerPage" id="itemsPerPage" className="form-control  text-end" 
                                value={itemsPerPage} 
                                onChange={updateitemsPerPage}>
                                {pageSizes.map((option, index) => {
                                return (
                                    <option key={index} value={option.value}>
                                        {option.label}
                                    </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>

                    {isAdmin &&
                    <div className="row mt-3 g-0">
                        <div className="col-md-12 text-end">
                            <label htmlFor="admin">Filter Admin Only</label>
                            <input type="checkbox" id="admin" name="admin" className="table-input" checked={filterAdmin} onChange={onAdminChanged} style={{marginRight: "20px"}}/>
                            <button className="btn btn-steel" onClick={onHepClicked}>
                                Remove uploaded HEPs
                            </button>
                        </div>
                    </div>
                    }


                </main>
            </section>
        )
    }

    return content
}
export default HepList